import React from "react";

export default function Vector() {
  return (
    <svg
      width="124"
      height="121"
      viewBox="0 0 124 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4787_41018)">
        <path
          d="M2.52629 56.6512C13.3191 91.1212 -7.7233 97.1112 13.9956 114.551C32.1681 129.111 64.2185 111.841 85.4352 119.651C99.9793 125.001 121.36 110.651 122.918 89.9812C124.353 70.9812 108.271 70.5612 112.463 49.4613C117.486 24.2413 117.25 0.78125 63.7061 0.78125C10.1622 0.78125 -7.03657 26.1212 2.52629 56.6512Z"
          fill="#CFD7DF"
        />
        <path
          d="M108.662 37.2402H14.3655C12.1012 37.2402 10.2656 39.0311 10.2656 41.2402V97.2402C10.2656 99.4494 12.1012 101.24 14.3655 101.24H108.662C110.926 101.24 112.761 99.4494 112.761 97.2402V41.2402C112.761 39.0311 110.926 37.2402 108.662 37.2402Z"
          fill="white"
          stroke="#B1BDC8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="0.79 2.54"
        />
        <path
          d="M106.089 33.2617H103.014V102.292H106.089V33.2617Z"
          fill="#EBEFF3"
        />
        <path
          d="M19.9518 33.2617H16.877V102.292H19.9518V33.2617Z"
          fill="#EBEFF3"
        />
        <path
          d="M106.089 33.2617H103.014V102.292H106.089V33.2617Z"
          fill="#EBEFF3"
        />
        <path
          d="M103.075 31.471V104.471C103.075 105.733 102.561 106.944 101.646 107.837C100.731 108.73 99.4904 109.231 98.1965 109.231H24.83C23.536 109.231 22.2951 108.73 21.3801 107.837C20.4652 106.944 19.9512 105.733 19.9512 104.471V23.211H33.8394L43.6892 12.291H84.8925"
          fill="white"
        />
        <path
          d="M103.075 31.471V104.471C103.075 105.733 102.561 106.944 101.646 107.837C100.731 108.73 99.4904 109.231 98.1965 109.231H24.83C23.536 109.231 22.2951 108.73 21.3801 107.837C20.4652 106.944 19.9512 105.733 19.9512 104.471V23.211H33.8394L43.6892 12.291H84.8925"
          stroke="#B1BDC8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M97.1508 31.0723H85.2715V12.3223C85.2715 12.3223 101.989 30.0723 103.014 31.0723"
          fill="#EBEFF3"
        />
        <path
          d="M97.1508 31.0723H85.2715V12.3223C85.2715 12.3223 101.989 30.0723 103.014 31.0723"
          stroke="#B1BDC8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M66.4629 74.3907L70.1322 77.9807L72.9509 75.3007L69.22 71.7207L66.4629 74.3907Z"
          fill="#CFD7DF"
        />
        <path
          d="M69.1595 77.7808L72.7879 74.1308C72.9222 73.999 73.0819 73.8944 73.2578 73.823C73.4337 73.7516 73.6223 73.7148 73.8128 73.7148C74.0034 73.7148 74.192 73.7516 74.3679 73.823C74.5438 73.8944 74.7035 73.999 74.8378 74.1308L84.9132 84.0008C85.6451 84.7361 86.0545 85.7208 86.0545 86.7458C86.0545 87.7708 85.6451 88.7555 84.9132 89.4908C84.5441 89.867 84.1017 90.1674 83.6119 90.3745C83.1222 90.5815 82.595 90.6911 82.0613 90.6967C81.5276 90.7023 80.9982 90.6038 80.504 90.407C80.0098 90.2102 79.5609 89.9191 79.1836 89.5508L69.1698 79.7808C69.034 79.6504 68.926 79.4952 68.8519 79.3239C68.7779 79.1526 68.7393 78.9688 68.7383 78.7829C68.7373 78.597 68.7741 78.4128 68.8464 78.2408C68.9187 78.0688 69.0251 77.9125 69.1595 77.7808Z"
          fill="#CFD7DF"
          stroke="#92A2B1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.3633 78.7714C65.5526 78.7714 73.8126 70.6946 73.8126 60.7314C73.8126 50.7682 65.5526 42.6914 55.3633 42.6914C45.1741 42.6914 36.9141 50.7682 36.9141 60.7314C36.9141 70.6946 45.1741 78.7714 55.3633 78.7714Z"
          stroke="#92A2B1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.8498 60.782C42.8417 59.173 43.1593 57.5783 43.7845 56.0894C44.4097 54.6006 45.33 53.2468 46.4928 52.1058C47.6556 50.9649 49.0379 50.0592 50.5603 49.4407C52.0827 48.8223 53.7154 48.5033 55.3645 48.502"
          stroke="#CFD7DF"
          strokeLinecap="round"
          strokeLinejoin="bevel"
        />
      </g>
      <defs>
        <clipPath id="clip0_4787_41018">
          <rect
            width="122.995"
            height="120"
            fill="white"
            transform="translate(0.015625 0.78125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
